var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114189",
    "data-name": "Rectangle 114189",
    width: 42,
    height: 42,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_295445",
    "data-name": "Group 295445",
    transform: "translate(-16376 -5917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_295444",
    "data-name": "Group 295444",
    transform: "translate(16376 5917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_295443",
    "data-name": "Group 295443",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225073",
    "data-name": "Path 225073",
    d: "M21,0A21,21,0,1,1,0,21,21,21,0,0,1,21,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4756",
    "data-name": "Ellipse 4756",
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "translate(0.5 0.5)",
    fill: "none",
    stroke: "red",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225074",
    "data-name": "Path 225074",
    d: "M18.96,11.488l3.075,1.2-9.181,3.57L9.637,15l9.04-3.515a.375.375,0,0,1,.283,0m9.576,10.268a4.676,4.676,0,1,1-4.676,4.676,4.677,4.677,0,0,1,4.676-4.676Zm1.77,2.543-2.77,2.77-.945-1.189a.677.677,0,0,0-1.059.842l1.391,1.75a.678.678,0,0,0,.944.168.733.733,0,0,0,.091-.076l3.306-3.306a.678.678,0,1,0-.918-1c-.014.013-.027.026-.04.04ZM25.319,13.961l-9.181,3.57,2.681,1.042L28,15Zm3.217,1.667-9.328,3.627v10.8l4.242-1.65a5.457,5.457,0,0,1,5.085-7.432ZM18.429,30.059v-10.8l-2.828-1.1v2.281a.129.129,0,0,1-.127.131.125.125,0,0,1-.086-.031l-1.5-1.278-1.4.436a.129.129,0,0,1-.161-.085.126.126,0,0,1-.006-.038V16.879L9.1,15.628V26.166a.383.383,0,0,0,.249.363Z",
    fill: "#00057d",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_225075",
    "data-name": "Path 225075",
    d: "M16409.094,5921.625l-24.98,31.774",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 710.474, -1681.364)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225076",
    "data-name": "Path 225076",
    d: "M24.5,30.94,0,0",
    transform: "matrix(-0.995, 0.105, -0.105, -0.995, 16410.699, 5952.027)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.13d430e9507cf652d7552be7312c13c1.svg";
export { ForwardRef as ReactComponent };